import {
  hideDownloadPage,
  hidePhotofeature,
  hideShopPage,
  revealPhotofeature,
  revealShopPage,
  revealSplashPrompt,
  revealRoarPrompt,
  hideTrollyButtonPrompt,
  revealLearnMorePage,
  hideLearnMorePage,
  hideRoarPrompt,
  revealFooterMain,
  revealFacePrompt,
  hideIntroRoarPrompt,
} from ".";
import { launch } from "..";

import { flipCamera } from "../components/camera";
import { elmoSwitchToDanceFilter, elmoSwitchToFaceFilter } from "../components/elmo";
import { hideFace, revealFace } from "../components/face";
import { hideMask, revealMask } from "../components/mask";
import { checkIfShouldShowRoarPrompt } from "../components/mouthLandmarks";
import { hideRoom, revealRoom } from "../components/room";
import { userSuitSwitchToDanceFilter, userSuitSwitchToFaceFilter } from "../components/userSuit";
import { playClickSound, playMusic, resetVideo, resumeAudioContext, stopRecording } from "../components/videoRecorderAndAudio";
import { sendTrackingEvent } from "../utils";

const launchButton = document.querySelector(".launchButton");
const splashPromptOkButton = document.querySelector(".splashPromptOkButton");
const trollyButton = document.querySelector(".trollyButton");
const shopGoBackButton = <HTMLButtonElement>document.querySelector(".shopGoBackButton");
const flipPhotofeatureButton = <HTMLButtonElement>document.querySelector(".flipPhotofeatureButton");
const backButton = <HTMLButtonElement>document.querySelector(".backButton");
const learnMoreButton = <HTMLButtonElement>document.querySelector(".learnMoreButton");
const learnMoreGoBackButton = <HTMLButtonElement>document.querySelector(".learnMoreGoBackButton");
const roarPromptButton = <HTMLButtonElement>document.querySelector(".roarPromptButton");

const amazonButton = <HTMLButtonElement>document.querySelector(".amazonButton");
const walmartButton = <HTMLButtonElement>document.querySelector(".walmartButton");

launchButton?.addEventListener("click", () => {
  sendTrackingEvent("User tapped 'launch' button");
  revealSplashPrompt();
  playClickSound();
  resumeAudioContext()

});

splashPromptOkButton?.addEventListener("click", () => {
  sendTrackingEvent("User tapped onboarding screen 'continue'");
  launch();
  playClickSound();

});

trollyButton?.addEventListener("click", () => {
  sendTrackingEvent("User tapped shop button");
  hidePhotofeature();
  revealShopPage();
  playClickSound();
  hideTrollyButtonPrompt();
});

shopGoBackButton?.addEventListener("click", () => {
  hideShopPage();
  revealPhotofeature();
  playClickSound();
});

flipPhotofeatureButton?.addEventListener("click", () => {
  sendTrackingEvent("User tapped flip camera button");
  playClickSound();
  flipCamera();
});

backButton?.addEventListener("click", () => {
  playClickSound();
  hideDownloadPage();
  revealPhotofeature();
  resetVideo();
});

learnMoreButton?.addEventListener("click", () => {
  revealLearnMorePage();
  hideShopPage();
});

learnMoreGoBackButton?.addEventListener("click", () => {
  hideLearnMorePage();
  revealShopPage();
});

roarPromptButton?.addEventListener("click", () => {
  playMusic();
  hideIntroRoarPrompt();
  revealPhotofeature();
  checkIfShouldShowRoarPrompt();
  flipCamera();
});

amazonButton?.addEventListener("click", () => {
  sendTrackingEvent("User tapped Amazon shop link");
});

walmartButton?.addEventListener("click", () => {
  sendTrackingEvent("User tapped Walmart shop link");
});
